<template>
  <MDBCard class="mb-3 mb-lg-4 welcome--main welcome__height" :class="[
    props.boxHeight,
  ]">
    <MailBoxContent v-if="useTyreBoxLeftColumnLayout" />
    <WelcomeBoxContentLV v-else />
  </MDBCard>
  <TyreBox v-if="showTyreBox" />
  <MailBox v-else-if="tenantConfig?.showMailBox && canSeeMailbox" />
</template>

<script setup>
import { MDBCard } from "mdb-vue-ui-kit";
import MailBox from "@/components/Dashboard/MailBoxLV.vue";
import MailBoxContent from "@/components/Dashboard/MailBoxContentLV.vue";
import TyreBox from "@/components/Dashboard/TyreBox.vue";
import WelcomeBoxContentLV from "@/components/Dashboard/WelcomeBoxContentLV.vue";
import { useStore } from "vuex";
import { computed, watch, ref, defineProps } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useItemsConditions } from "@/composables/useItemsConditions";
import TokenService from "@/services/storage.service";

const props = defineProps({
  boxHeight: { type: String, default: "welcome__height" },
});
const store = useStore();
const { tenantConfig } = useTenantConfig();
const { canSeeMailbox } = useItemsConditions();
const user = computed(() => store.getters.getMe);
const permissions = computed(() => store.getters.getPermissions);
const useTyreBoxLeftColumnLayout = computed(
  () => tenantConfig.value?.useTyreBoxLeftColumnLayout && TokenService.showElement("messageBox.see")
);
const showTyreBox = computed(
  () =>
    useTyreBoxLeftColumnLayout.value &&
    permissions.value &&
    TokenService.showElement("tyreBox.see")
);

const isWholesaler = ref(false);
const isWholesalerStaff = ref(false);
const isStaff = ref(false);

watch(user, async (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "wholesaler")) {
    isWholesaler.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "wholesalerStaff")) {
    isWholesalerStaff.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "staff")) {
    isStaff.value = true;
  }
});
</script>

<style scoped lang="scss">
@import "@/styles/left_column.scss";
</style>
